import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import IStructureTypeProps from "./IStructureType";
// import ActiveCheck from "../../../assets/images/checked.svg" ;//"../../../assets/images/checked.svg";
import "../../../assets/sass/widgets/structureType.scss";
import {
    handleEnter,
    checkForReadOnly,
    checkForPriceChanges,
    valueResolver,
    imagePathurl,
    dateTimeFormatter,
} from "../../utils/utils";
import { fetchAPI } from "../../utils/service";
import endpoints, { endpointTypes } from "../../service";
import * as globalErrorActionCreators from "../../globalStore/actions";
import * as dynamicFormActionCreators from "../../components/DynamicForm/actionCreators";
import ReactGA from "react-ga";
interface IStructureTypeStateProps {
    error?: any;
    previousValue?: any;
    structureValue?: any;
}
/**
 * @class StructureType
 * @category Widgets
 * @description this component renders the ui for structure type boxes and the StructureType
 actions, the user can select one of the boxes that is showing for structure type by clicking it

 */
class StructureType extends React.Component<IStructureTypeProps, IStructureTypeStateProps> {
    constructor(props) {
        super(props);
        this.state = {
            previousValue: this.props.value,
            structureValue: this.props.value,
            error: { error: false, errorMessage: [] },
        };
        this.structureTypeChange = this.structureTypeChange.bind(this);
    }
    componentDidMount() {
        if (!this.props.value) {
            this.setState({ structureValue: this.props.schema.default }, () => {
                this.props.onChange(this.props.schema.default);
            });
        }
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        const { value, schema } = this.props;
        const { value: prevValue } = prevProps;
        if (value && value !== prevValue) {
            this.props.onChange(value);
        } else if (!value && value !== prevValue) {
            this.props.onChange(schema.default);
        }
    }
    checkForPrice = (e) => {
        this.props.dynamicFormActions.apiRunningStatus(true);
        const { family } = this.props.schema.const;
        const { errorSchema } = this.props;
        const id = this.props.id.split("_");
        const fieldName = this.props.id.split("_")[id.length - 1];
        const dataValidatorPath =
            errorSchema &&
            errorSchema.length &&
            errorSchema.filter((key) =>
                key.parentDependency ? key.key === fieldName && key.parentDependency === family : key.key === fieldName
            );
        const priceCheck = dataValidatorPath[0].value.filter((val) => val.validationType === "priceCheck");
        let reqObject;
        for (const i in JSON.parse(priceCheck[0].value)) {
            reqObject = {
                ...reqObject,
                [i]: valueResolver(this.props.warrantyData, JSON.parse(priceCheck[0].value)[i].trim()),
                [fieldName]: e,
            };
        }
        const requestobject = {
            data: reqObject,
            warrantyId: this.props.warrantyId,
        };
        reqObject.api = priceCheck[0].api;
        const successCallBackEditCheck = async () => {
            const formLayoutRoute = endpoints[endpointTypes.FORMLAYOUT];
            const editableCheckEndpoint = formLayoutRoute.endpoints.checkEditable(requestobject);
            try {
                const response = await fetchAPI(editableCheckEndpoint);
                return response;
            } catch (err) {
                this.setState({
                    structureValue: this.state.previousValue,
                    error: { error: true, errorMessage: [priceCheck[0].message] },
                });
                this.props.dynamicFormActions.apiRunningStatus(false);
                this.props.globalErrorActions.showGlobalError(err);
            }
        };
        return successCallBackEditCheck();
    };

    async structureTypeChange(data) {
        const { family } = this.props.schema.const;
        const { errorSchema, schema, isSubmittedForm } = this.props;
        const id = this.props.id.split("_");
        const fieldName = this.props.id.split("_")[id.length - 1];
        const dataValidatorPath =
            errorSchema &&
            errorSchema.length &&
            errorSchema.filter((key) =>
                key.parentDependency ? key.key === fieldName && key.parentDependency === family : key.key === fieldName
            );
        const priceCheck = dataValidatorPath[0].value.filter((val) => val.validationType === "priceCheck");
        if (
            this.state.structureValue !== data &&
            priceCheck &&
            priceCheck.length > 0 &&
            checkForPriceChanges(schema.const, isSubmittedForm)
        ) {
            const x = await this.checkForPrice(data);
            const {
                warrantyInfo,
                warrantyId,
                waiverReceived,
                dynamicFormActions: { submitWarranty },
            } = this.props;
            if (x && x.data && x.data.isPriceChanged) {
                this.props.dynamicFormActions.submitClicked(false);
                this.props.dynamicFormActions.apiRunningStatus(false);
                this.props.dynamicFormActions.navigationClickDetails({});
                this.setState(
                    {
                        error: { error: true, errorMessage: [priceCheck[0].message] },
                        structureValue: this.state.previousValue,
                    },
                    () => {
                        this.props.onChange(this.state.previousValue);
                    }
                );
            } else if (x && x.data && !x.data.isPriceChanged && this.props.isSubmitClicked) {
                // submit form only if there is no price change
                const handleSubmitError = (data) => {
                    const validationMessage = (data.errors && data.errors.validationMessage) || "";
                    if (validationMessage) {
                        const payload = {
                            errors: data.errors,
                        };
                        this.props.globalErrorActions.showGlobalError({ Message: validationMessage });
                        this.props.dynamicFormActions.fetchFormErrorResponseSuccess(payload);
                    }
                };
                const successCallBack = (data) => {
                    this.props.dynamicFormActions.submitClicked(false);
                    this.props.dynamicFormActions.apiRunningStatus(false);
                    window["AppInsightTrace"].trackTrace(`on submit form click successCallBack`);
                    ReactGA.event({
                        category: "Submit Form",
                        action: `Submit Form: ${data.id}`,
                        label: `Submit Form: ${data.id} : ${dateTimeFormatter(data.saveTime)}`,
                    });
                    handleSubmitError(data);
                };
                const failureCallback = (data) => {
                    let commonErrorMsg = "";
                    const validationMessage = (data.errors && data.errors.validationMessage) || "";
                    if (validationMessage) {
                        handleSubmitError(data);
                    } else if (data && data.response && data.response.data && data.response.data.Message) {
                        commonErrorMsg = data.response.data.Message;
                        window["AppInsightTrace"].trackException(`on submit form click Failure: ${commonErrorMsg} `);
                    } else {
                        const globalErrorMsg = this.props.globalErrorActions.showGlobalError(
                            (data && data.response && data.response.data) || ""
                        );
                        commonErrorMsg = globalErrorMsg.payload.errorMessage;
                        window["AppInsightTrace"].trackException(
                            `on submit form click global Failure: ${commonErrorMsg}`
                        );
                    }
                    ReactGA.event({
                        category: "Error",
                        action: `Error: ${commonErrorMsg}`,
                        label: `Error: ${commonErrorMsg}`,
                    });
                    this.props.dynamicFormActions.submitClicked(false);
                    this.props.dynamicFormActions.apiRunningStatus(false);
                };
                setTimeout(() => {
                    const payload = {
                        payload: {
                            Id: warrantyId,
                            formData: warrantyInfo,
                            WaiverReceived: waiverReceived,
                            successCallBack: successCallBack,
                            failureCallback: failureCallback,
                        },
                    };
                    submitWarranty(payload);
                }, 1000);
            } else if (
                x &&
                x.data &&
                !x.data.isPriceChanged &&
                this.props.clickDetails &&
                this.props.clickDetails.clickId
            ) {
                this.props.dynamicFormActions.apiRunningStatus(false);
                if (document.getElementById(this.props.clickDetails.clickId))
                    document.getElementById(this.props.clickDetails.clickId).click();
            } else {
                this.setState({ structureValue: data }, () => {
                    this.props.onChange(data);
                    this.props.dynamicFormActions.apiRunningStatus(false);
                });
            }
        } else {
            this.setState({ structureValue: data }, () => {
                this.props.onChange(data);
            });
        }
    }

    render() {
        const { id, schema, isSubmittedForm } = this.props;
        const { structureValue } = this.state;
        //image CDN_PATH
        const getimagePath = imagePathurl();
        return (
            <div id={id} className="row gaf-structure-type-container">
                {schema.anyOf.map((option, index) => (
                    <div
                        key={`${id} ${index}`}
                        className={`col-xs-6 col-sm-5 col-md-3 col-lg-3 plain-card ${
                            structureValue === option.enum[0] ? "active-card" : ""
                        }`}
                        onClick={
                            checkForReadOnly(schema.const, isSubmittedForm)
                                ? () => {}
                                : () => this.structureTypeChange(option.enum[0])
                        }
                        role="button"
                        tabIndex={option.const.tabIndex}
                        onKeyPress={handleEnter}
                    >
                        <img className="active-icon" src={`${getimagePath}checked.svg`} alt={index} />
                        <img
                            className="plain-card-icon"
                            src={`${getimagePath}${option.const.imgsrc}`}
                            alt={option.title}
                        />
                        <div className="plain-card-label">{option.title}</div>
                    </div>
                ))}
                {this.state.error && this.state.error.error && this.state.error.errorMessage.length > 0 && (
                    <div className="error-message">
                        {this.state.error.errorMessage.map((msg, id) => (
                            <p key={id}>{msg}</p>
                        ))}
                    </div>
                )}
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        warrantyInfo: state.dynamicFormInfo.warrantyInfo,
        isSubmittedForm: state.adminData.isSubmittedForm,
        warrantyId: state.dynamicFormInfo.warrantyId,
        warrantyData: state.dynamicFormInfo.layoutResponse.WarrantyData,
        isSubmitClicked: state.dynamicFormInfo.isSubmitClicked,
        waiverReceived: state.adminData.waiverReceived,
        clickDetails: state.dynamicFormInfo.clickDetails,
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        dynamicFormActions: bindActionCreators(dynamicFormActionCreators, dispatch),
        globalErrorActions: bindActionCreators(globalErrorActionCreators, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(StructureType);
